import { FIXED_LIMITS } from '@lagerfeuer/shared';
import { useEffect, useState, type FormEvent } from 'react';
import { Link, useSearchParams } from 'react-router';
import { errorMessage } from '../../lib/api';
import { authApi } from '../../lib/endpoints';
import { AuthLayout } from './AuthLayout';

/** Passwort mit einem vom Admin erzeugten Token zurücksetzen (`/reset-password?token=…`). */
export function ResetPasswordScreen() {
  const [params] = useSearchParams();
  const [token, setToken] = useState(params.get('token') ?? '');
  // Token nicht in Adresszeile/Verlauf/Lesezeichen stehen lassen.
  useEffect(() => {
    if (new URLSearchParams(window.location.search).has('token')) window.history.replaceState(window.history.state, '', '/reset-password');
  }, []);
  const [pw, setPw] = useState('');
  const [pw2, setPw2] = useState('');
  const [error, setError] = useState<string | null>(null);
  const [done, setDone] = useState(false);
  const [busy, setBusy] = useState(false);

  const submit = async (e: FormEvent) => {
    e.preventDefault();
    if (pw.length < FIXED_LIMITS.passwordMin) return setError(`Mindestens ${FIXED_LIMITS.passwordMin} Zeichen.`);
    if (pw !== pw2) return setError('Passwörter stimmen nicht überein.');
    setBusy(true);
    setError(null);
    try {
      await authApi.resetPassword({ token: token.trim(), newPassword: pw });
      setDone(true);
    } catch (err) {
      setError(errorMessage(err));
    } finally {
      setBusy(false);
    }
  };

  if (done) {
    return (
      <AuthLayout title="Passwort geändert" testId="reset-done">
        <Link className="btn btn-primary btn-block" to="/login">
          Jetzt anmelden
        </Link>
      </AuthLayout>
    );
  }
  return (
    <AuthLayout title="Neues Passwort" testId="reset-screen">
      <form onSubmit={submit}>
        <div className="field">
          <label htmlFor="reset-token">Rücksetz-Code</label>
          <input id="reset-token" className="input" value={token} onChange={(e) => setToken(e.target.value)} required data-testid="reset-token" />
        </div>
        <div className="field">
          <label htmlFor="reset-pw">Neues Passwort</label>
          <input id="reset-pw" type="password" className="input" autoComplete="new-password" value={pw} onChange={(e) => setPw(e.target.value)} data-testid="reset-password" />
        </div>
        <div className="field">
          <label htmlFor="reset-pw2">Wiederholen</label>
          <input id="reset-pw2" type="password" className="input" autoComplete="new-password" value={pw2} onChange={(e) => setPw2(e.target.value)} data-testid="reset-password2" />
        </div>
        {error && (
          <p className="error-text" role="alert">
            {error}
          </p>
        )}
        <button className="btn btn-primary btn-block" disabled={busy || !token} data-testid="reset-submit">
          Passwort setzen
        </button>
      </form>
    </AuthLayout>
  );
}
